module.exports = __webpack_public_path__ + "img/5_90.dce6eca6.png";